<script>
    export let type = 'primary';
    export let flat = false;
    export let inverse = false;
    export let round = false;
 
</script>

<button class={type} class:flat={flat} class:inverse={inverse} class:round={round} on:click>
    <slot></slot>
</button>

<style>
    button{
        border: 0;
        cursor: pointer;
        border-radius: 6px;
        padding: 8px 12px;
        font-weight: bold;
        box-shadow: 1px 2px 3px rgba(0,0, 0, 0.2);
        margin: 8px;
    }
    .primary{
        background: #df8d9d;
        color: white;
    }
    .secondary{
        background: #45c496;
        color: white;
    }
    .flat {
        box-shadow: none;
    }
    .primary.inverse{
        color: #df8d9d;
        background: white;
    }
    .secondary.inverse{
        color: #45c496;
        background: white;
    }
    .round {
        height: 45px;
        width: 45px;
        border-radius: 50%;
    }

</style>